import { Municipio } from 'src/app/Models/municipio.model';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Participante } from '../Models/participante.model';
import { RespostaWebAPI } from '../Models/resposta-web-api.model';
import { UserToken } from '../Models/token.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class MunicipioService {

  constructor(private http: HttpClient) { }

  get(): Observable<Municipio[]> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'  });
    return this.http.get<Municipio[]>(`${environment.apiUrl}municipio`, { headers: headers });
  }

}